import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=7fab32ff&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"
import style0 from "./Process.vue?vue&type=style&index=0&id=7fab32ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab32ff",
  null
  
)

export default component.exports